import { App } from 'antd';

/**
 * Hook customizado para mensagens toast padronizadas
 * Usa o contexto do App do Ant Design 5 para mensagens
 */

interface ToastOptions {
  duration?: number;
}

export function useToast() {
  const { message } = App.useApp();

  /**
   * Mensagem de sucesso
   */
  const success = (content: string, options?: ToastOptions) => {
    return message.success({
      content,
      duration: options?.duration ?? 3,
    });
  };

  /**
   * Mensagem de erro
   */
  const error = (content: string, options?: ToastOptions) => {
    return message.error({
      content,
      duration: options?.duration ?? 4,
    });
  };

  /**
   * Mensagem de aviso
   */
  const warning = (content: string, options?: ToastOptions) => {
    return message.warning({
      content,
      duration: options?.duration ?? 3,
    });
  };

  /**
   * Mensagem informativa
   */
  const info = (content: string, options?: ToastOptions) => {
    return message.info({
      content,
      duration: options?.duration ?? 3,
    });
  };

  /**
   * Mensagem de carregamento
   */
  const loading = (content: string = 'Carregando...', duration: number = 0) => {
    return message.loading({
      content,
      duration,
    });
  };

  /**
   * Destrói todas as mensagens
   */
  const destroy = () => {
    message.destroy();
  };

  return {
    success,
    error,
    warning,
    info,
    loading,
    destroy,
  };
}

